export default __webpack_public_path__ + "97b0bfd848990d678f3306960a5c12e4.png";